import React from "react";
import { Facebook, Linkedin, Instagram, Youtube } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Company Info */}
        <div>
          <h2 className="text-2xl font-bold text-red-500">Talennect </h2>
          <p className="mt-2">
            Your go-to choice for global workforce solutions.
          </p>
          <p className="mt-4 font-bold">US Headquarter</p>
          <p>30 N Gould St Ste R Sheridan</p>
          <p>WY 82801-6317</p>
          <p className="mt-4 font-bold">India Headquarter</p>
          <p>G835 Sector 63 Noida</p>
          <p>Uttar Pradesh, India</p>
        </div>

        {/* About Us */}
        <div>
          <h3 className="text-lg font-bold mb-3">About Us</h3>
          <ul className="space-y-2">
            <li>Our Mission</li>
            <li>Our Vision</li>
            <li>Why Us</li>
            <li>Leadership Team</li>
            <li>Diversity & Inclusion</li>
          </ul>
        </div>

        {/* Workforce Solutions */}
        <div>
          <h3 className="text-lg font-bold mb-3">Workforce Solutions</h3>
          <ul className="space-y-2">
            <li>Contingent Staffing</li>
            <li>Direct Hire</li>
            <li>Payroll Services</li>
            <li>Consulting</li>
            <li>Nearshore / Onshore</li>
            <li>Direct Sourcing</li>
            <li>RPO</li>
          </ul>
        </div>

        {/* Contact Us & Social Media */}
        <div>
          <h3 className="text-lg font-bold mb-3">Contact Us</h3>
          <ul className="space-y-2">
            <li>Chatbot</li>
            <li>Request Services</li>
            <li>Submit Resume</li>
            <li>Global Presence</li>
            <li>Contact Us</li>
          </ul>

          {/* Social Media Icons */}
          <div className="flex space-x-4 mt-4">
            <a href="#" className="text-gray-400 hover:text-white transition">
              <Facebook size={20} />
            </a>
            <a
              href="https://www.youtube.com/@Talennect"
              className="text-gray-400 hover:text-white transition"
            >
              <Youtube size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/talennect/"
              className="text-gray-400 hover:text-white transition"
            >
              <Linkedin size={20} />
            </a>
            <a
              href="https://www.instagram.com/talennect/"
              className="text-gray-400 hover:text-white transition"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="text-center text-gray-400 mt-6 text-sm border-t border-gray-700 pt-4">
        Copyright © 20022 - 2025 Talennect | All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
